import CONSTANTS from "@/constants/index"

export const keyboardEvents = (i, e) => {
  const { KEYCODE } = CONSTANTS
  const ele = e.target.parentNode.childNodes
  switch (e.keyCode) {
    case KEYCODE.UP:
      e.preventDefault()
      if (i > 0) ele[i - 1].focus()
      break
    case KEYCODE.DOWN:
      e.preventDefault()
      if (i < ele.length - 1) ele[i + 1].focus()
      break
    case KEYCODE.SPACE:
    case KEYCODE.ENTER:
      e.preventDefault()
      ele[i].querySelector("input").click()
      break
    default:
      break
  }
}
